import { render } from "./PartProducts.vue?vue&type=template&id=e9e120c8"
import script from "./PartProducts.vue?vue&type=script&lang=js"
export * from "./PartProducts.vue?vue&type=script&lang=js"

import "./PartProducts.vue?vue&type=style&index=0&id=e9e120c8&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__